import { AttributionTable } from './attribution-table';
import { BrandsAttributionTable } from './brands-attribution-table';

export { AttributionTable, BrandsAttributionTable };
